/**
 * @readonly
 * @enum {number}
 */
export const WebMetricDateRangePeriodType = {
    current: 1,
    today: 2,
    todayMinus7: 3,
    todayMinus30: 4,
    todayMinus90: 5,
    todayMinus180: 6,
    custom: 7
}

/**
 * @readonly
 * @enum {number}
 */
export const StopListItemDocumentDirection = {
    FromSmrToDmsis: 0,
    FromSmrToClient: 1,
    FromDmsisToSmr: 2
}